module.exports = __webpack_public_path__ + "media/shop.795afe27.mp4";